// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1PXiP","left":"styles_left__2BBIg","right":"styles_right__21_U1","alert":"styles_alert__UyYHr"};